<script setup lang="ts">
import { StrongG } from '@/atoms/global'
import { ButtonState } from '@/atoms/NitButton/types'
import ModalWithButtons from '@/components/Modal/ModalWithButtons.vue'
import { switchTeam } from '@/helpers/apiClient'
import { useNotificationStore } from '@/store/notificationStore'

import { useTeamStore } from '@/store/teamStore'
const showDeclineConfirmation = ref(false)
const teamStore = useTeamStore()
const { invitation } = storeToRefs(teamStore)

const approveButtonState = ref<ButtonState>('available')
const approve = async () => {
  approveButtonState.value = 'loading'
  await invitation.value?.member.approveInvitation()

  const teamId = invitation.value?.team?.id
  await switchTeam(teamId!)
  useNotificationStore().showNotification('チームへの参加を承認しました！')

  await useTeamStore().setup()
  // 複数チームに同時招待されている場合、承認後もinvitationが次の招待に差し替わり
  // モーダルがアンマウントされずloading状態が残るため、明示的に戻す
  approveButtonState.value = 'available'
}

const decline = async () => {
  await invitation.value?.member.delete()
}
</script>
<template>
  <div v-if="invitation">
    <!-- メイン画面 -->
    <ModalWithButtons
      v-if="!showDeclineConfirmation"
      :title="'チームに招待されています'"
      :show-close-button="false"
    >
      <template #contents>
        <description>
          {{ invitation.team.name }}へ招待されています。
        </description>
      </template>
      <template #first-button>
        <NitButton
          :width="'100%'"
          :button-state="approveButtonState"
          @click="approve"
        >
          承認する
        </NitButton>
      </template>
      <template #second-button>
        <NitButton
          :type="'error'"
          :width="'100%'"
          @click="showDeclineConfirmation = true"
        >
          拒否する
        </NitButton>
      </template>
    </ModalWithButtons>
    <!-- 拒否しようとした場合にすすむ確認モーダル -->
    <ModalWithButtons
      v-else
      :title="'招待を拒否してよろしいですか？'"
      :show-close-button="false"
    >
      <template #contents>
        <strong-g class="lo-v-center">
          <img src="@/assets/icons/warning-red.svg" />
          <description class="mg-top-8px">
            招待の拒否は取り消すことができません。本当によろしいですか？
          </description>
        </strong-g>
      </template>
      <template #first-button>
        <NitButton
          :type="'tertiary'"
          :width="'100%'"
          @click="showDeclineConfirmation = false"
        >
          戻る
        </NitButton>
      </template>
      <template #second-button>
        <NitButton :type="'error'" :width="'100%'" @click="decline">
          拒否する
        </NitButton>
      </template>
    </ModalWithButtons>
  </div>
</template>
